import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  GetScriptsureProfileUrlTypeEnum,
  ScriptSureControllerApiFactory,
} from "../../services";
import { getConfigObject, useBaseContent } from "../../utils/utils";

interface Props {
  patientUuid: string;
  type: GetScriptsureProfileUrlTypeEnum;
  xTENANTID: string;
  providerId: string;
  enabled?: boolean; // Add optional enabled parameter
}

/**
 *
 * @author Atish Bagate
 *
 */
export const useGetPatientScriptsureUrl = ({
  patientUuid,
  providerId,
  type,
  xTENANTID,
  enabled = false, // Default to false for manual control
}: Props): useBaseContent<any> => {
  return useQuery({
    queryKey: [
      "get-patient-scriptsure-url",
      patientUuid,
      providerId,
      type,
      xTENANTID,
    ],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled: enabled && !!patientUuid && !!providerId && !!type && !!xTENANTID, // Use enabled parameter
    queryFn: async () =>
      await ScriptSureControllerApiFactory(getConfigObject())
        .getScriptsureProfileUrl(patientUuid, providerId, type, xTENANTID)
        .then((res) => res?.data),
  });
};
